export const auth = {
  login: {
    title: 'Log in to your account',
    subtitle: 'Welcome back! Please enter your details.',
    emailLabel: 'Email',
    passwordLabel: 'Password',
    forgotPasswordLink: 'Forgot password?',
    submit: 'Login',
  },
  register: {
    legacy: {
      title: 'Welcome!',
      subtitle: 'Set your password to complete registration',
      passwordLabel: 'Password',
      passwordPlaceholder: '••••••••',
      passwordHint: 'At least 8 characters',
      confirmPasswordLabel: 'Confirm Password',
      submit: 'Create Account',
    },
    invitation: {
      title: 'Create your account',
      subtitleEarlyAdopter: 'Thanks for being an early adopter of Queri',
      subtitleDefault: 'Complete your account setup to get started',
      subtitleJoin: (organization: string) => `Join ${organization} on Queri`,
      accountFor: 'Your account',
      firstNameLabel: 'First Name',
      firstNamePlaceholder: 'John',
      lastNameLabel: 'Last Name',
      lastNamePlaceholder: 'Doe',
      emailLabel: 'Email',
      emailPlaceholder: 'john.doe@company.com',
      passwordLabel: 'Password',
      passwordPlaceholder: '••••••••',
      passwordHint: 'At least 8 characters',
      confirmPasswordLabel: 'Confirm Password',
      companyLabel: 'Company',
      companyPlaceholder: 'Acme Inc.',
      jobTitleLabel: 'Job Title',
      jobTitlePlaceholder: 'Legal Counsel',
      legalHoursOptional: 'Optional:',
      legalHoursQuestion:
        'How many hours per week do you think you spend on legal matters (including working on legal documents)?',
      legalHoursPlaceholder: 'e.g. 20',
      submit: 'Create Account',
    },
    invalid: {
      titleExpired: 'Link Expired',
      titleUsed: 'Link Already Used',
      titleInvalid: 'Invalid Link',
      contactHint:
        'Please contact the person who invited you to request a new invitation link.',
    },
  },
  forgotPassword: {
    title: 'Forgot your password?',
    subtitle: "Enter your email and we'll send you a reset link.",
    emailLabel: 'Email',
    emailPlaceholder: 'Enter your email',
    submit: 'Send Reset Link',
    sending: 'Sending...',
    backToLogin: 'Back to login',
    submitted: {
      title: 'Check your email',
      subtitle:
        "If an account exists with that email, we've sent you a link to reset your password.",
      expiryNote:
        "The link will expire in 1 hour. If you don't see the email, check your spam folder.",
    },
  },
  resetPassword: {
    title: 'Reset your password',
    subtitle: 'Enter your new password below.',
    newPasswordLabel: 'New Password',
    newPasswordPlaceholder: 'Enter new password',
    confirmPasswordLabel: 'Confirm Password',
    confirmPasswordPlaceholder: 'Confirm new password',
    passwordRequirement: 'Password must be at least 8 characters long.',
    submit: 'Reset Password',
    backToLogin: 'Back to login',
    success: {
      title: 'Password Reset Successful',
      subtitle:
        'Your password has been updated. You can now log in with your new password.',
      goToLogin: 'Go to Login',
    },
    invalidToken: {
      title: 'Invalid Reset Link',
      subtitle: 'This password reset link is invalid or has expired.',
      requestNewLink: 'Request a new reset link',
    },
  },
  errors: {
    noInvitationCode: 'No invitation code provided',
    invitationExpired: 'This invitation link has expired',
    invitationUsed: 'This invitation has already been used',
    signUpCodeRequired: 'Sign up code is required',
    invitationCodeRequired: 'Invitation code is required',
    hoursPerWeekInvalid: 'Hours per week must be a valid number',
    passwordsDoNotMatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 8 characters',
    invalidResetLink: 'Invalid reset link',
  },
};

export type AuthDict = typeof auth;
